import React from "react";

/**
 * TrustSignals — Subtle one-line trust signal above OAuth buttons.
 *
 * Design principle: Subtlety over hype. Users trust clean UI and familiar
 * OAuth providers — not walls of security marketing. One understated line
 * is all that's needed.
 */
export const TrustSignals: React.FC = () => {
  return (
    <div
      className="trust-signals"
      id="trust-signals"
      aria-label="Security information"
    >
      <p className="trust-line">🔒 Encrypted · Canadian data residency</p>
    </div>
  );
};
